// extracted by mini-css-extract-plugin
export default {"app-aside-nav":"f6646c","app-aside-nav__list":"ef9ff9","app-aside-nav__list-item":"ae6a6e"};